import {
    LOAD_FILE_LIST,
    LOAD_FILE_LIST_SUCCESS,
    SAVE_FILE_ID,
    WIPE_FILE_LIST,
    DELETE_FILE,
    DELETE_FILE_SUCCESS
} from 'constants/ActionTypes';


export const loadFiles = (user_id) => {
    return {
      type: LOAD_FILE_LIST,
      payload: user_id
    };
  };

  export const loadFileListSuccess = (files) => {
    return {
      type: LOAD_FILE_LIST_SUCCESS,
      payload: files
    }
  };

  export const wipeList = () => {
    return {
      type: WIPE_FILE_LIST
    }
  };

  export const saveFileID = (fileID) => {
    return {
      type: SAVE_FILE_ID,
      payload: fileID
    }
  };

  export const deleteFile=(fileID) =>{
    return {
      type: DELETE_FILE,
      payload: fileID
    }
  };

  export const deleteFileSuccess=() =>{
    return {
      type: DELETE_FILE_SUCCESS
    }
  };


  